import React from "react";
import {
  Grid,
  TableBody,
  CardContent,
  Divider,
  Card,
  TableContainer,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { RobotFont } from "components/ui/RobotFont";
import { readableFormatDate, toastSuccess, toastWarning } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";
import KisshtButton from "components/ui/KisshtButton";
import { ROUTE_NAME, PERMISSIONS } from "shared/constants";
import { captureRazorpayPayment } from "shared/api/subuser";

const RazorpayDetails = ({ data, payment_ref_no, setSpin }) => {
  let amount = data["amount"]; //(data["amount"] / 100).toFixed(2);
  let tax = data["tax"];
  let fee = data["fee"];

  const captureHandler = async (e) => {
    e.preventDefault();
    try {
      setSpin(true);
      const res = await captureRazorpayPayment(payment_ref_no);
      if (res.success) {
        toastSuccess(res.message);
        document.location.reload();
      } else {
        toastWarning(res.message);
      }
      setSpin(false);
    } catch (error) {
      setSpin(false);
    }
  };

  return (
    <>
      <Card>
        <CardContent className="card-content_head">
          <Grid container alignItems="center">
            <Grid item lg={6} md={6} sm={6} xs={8}>
              Razorpay Details
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
              >
                {!data["captured"] ? (
                  <Grid item>
                    <KisshtButton
                      onClick={captureHandler}
                      route={ROUTE_NAME.subuser_payment}
                      permission={PERMISSIONS.subuser_payment.capture}
                      className="common_kissht_btn"
                    >
                      Capture Payment
                    </KisshtButton>
                  </Grid>
                ) : null}

                {/* <Grid item>
                  <KisshtButton
                    onClick={() => setFailure(true)}
                    route={ROUTE_NAME.payment}
                    permission={PERMISSIONS.payment.details}
                  >
                   Payment Details
                  </KisshtButton>
                </Grid> */}

                {/* <Grid item>
                <Button variant="contained" color="primary">
                  Sync Payment
                </Button>
              </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <CustomTableWrapper>
            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <table className="w-full">
                <TableBody>
                  <TableBodyCell className="common_table_title">Order Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["razorpay_order_id"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["razorpay_payment_id"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Credentials Of</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["credentials_of"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Amount</TableBodyCell>
                  <TableBodyCell className="common_table_content">{`${amount} Paise`}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Fee / Tax</TableBodyCell>
                  <TableBodyCell className="common_table_content">{`${fee} Paise / ${tax} Paise`}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Status</TableBodyCell>
                  <TableBodyCell>
                    <BootstrapBadge text={data["status"]} />
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Is Captured</TableBodyCell>
                  <TableBodyCell>
                    <BootstrapBadge
                      backgroundColor="#0ABB87"
                      text={data["captured"] ? "Yes" : "No"}
                    />
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Email</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["email"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Contact</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["contact"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Error Code</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["error_code"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Error Description</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["error_description"]}</TableBodyCell>
                </TableBody>
              </table>
              </TableContainer>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <table className="w-full">
                <TableBody>
                  <TableBodyCell style={{ whiteSpace: "nowrap" }} className="common_table_title">
                    Payment Timestamp
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["payment_timestamp"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Method</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["method"]}</TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableBodyCell className="common_table_title">Description</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["description"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Card Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["card_id"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Bank</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["bank"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Wallet</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["wallet"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Vpa</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["vpa"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Notes</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["notes"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell style={{ whiteSpace: "nowrap" }} className="common_table_title">
                    Amount Refunded
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <RobotFont type="medium">₹</RobotFont>
                    {data["amount_refunded"]}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Refund Status</TableBodyCell>
                  <TableBodyCell>
                    <BootstrapBadge
                      text={data["refund_status"] ? data["refund_status"] : ""}
                    />
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["created_at"])}
                  </TableBodyCell>
                </TableBody>
              </table>
              </TableContainer> 
            </Grid>
          </CustomTableWrapper>
        </CardContent>
      </Card>
    </>
  );
};
export default RazorpayDetails;
